<template>
  <div class="HomePage">
    <div class="Page1">
      <div id="swiper" class="container-fuild">
        <div class="swiper-container banner-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
              <img class="swiper-lazy" :src="item.image" alt="轮播图">
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <!-- <div class="content">
        <div class="title">{{ $translate('home', 'title') }}</div>
        <div class="text">
          <div>{{ $translate('home', 'text1') }}</div>
          <div>{{ $translate('home', 'text2') }}</div>
        </div>
        <div class="text-en">
          <div>Xiamen UDIAN group is a strong petrochemical enterprise, focusing on the</div>
          <div> research and development, production and wholesale of lubricating oil and</div>
          <div> chemical products for a long time. The company has an independent</div>
          <div> production base, an independent headquarters, an operation center and</div>
          <div> a major regional sales center.</div>
        </div>
      </div> -->
    </div>
    <section class="Production">
      <img class="left-img" src="../assets/img/aboutme_img1.png" alt="">
      <img class="left-img1" src="../assets/img/Slice.png" alt="">
      <div class="right">
        <img class="text-img" src="../assets/img/home_adoutme_bg.png" alt="">
        <div class="title">
          <div>About us</div>
          <div>关于我们</div>
        </div>
        <div class="text-1">
          <div class="company">
            厦门油典集团有限公司
            <img class="address-icon" src="../assets/img/aboutme_icon.png" alt="">
            <span class="address">
              福建-厦门(运营总部）
            </span>
          </div>
          <div class="company-en">XiaMen UDIAN group</div>
          <div class="company-introduction">
            国家高新技术企业，致力于金属加工领域，专业研发、生产和销售金属加工油液、工业润滑油、防锈材料以及金属加工油液的复合添加剂。
          </div>
        </div>
        <img src="../assets/img/aboutme_img2.png" alt="" class="production-bottom-img1">
        <img src="../assets/img/Slice.png" alt="" class="production-bottom-img2">
        <div class="production-bottom-content">
          <div class="production-bottom-purpose">企业宗旨</div>
          <div class="production-bottom-purpose-en">Corporate purpose</div>
          <div class="production-bottom-purpose-title">
            质量是立足市场的根本，创新是企业发展的命脉，诚信是长久合作的保障。
          </div>
          <div class="production-bottom-purpose-text">
            公司以高标准、高技术、高效率为企业的发展目标，建立了以满足市场需求为核心的企业经营理念，致力于发展润滑油事业，寻求全国各地合作伙伴，建立长久合作关系，共同发展和进步。坚持强化服务意识、竞争意识、优胜劣汰，贯彻客户至上的理念，将服务客户视为无上的光荣，使高品质的产品和专业级的服务成为企业价值的源泉。
          </div>
        </div>
      </div>
    </section>
    <section class="Production1" :style="productionindex == 2 ? 'background:#fff' : ''">
      <div class="Production1Content">
        <div class="Production1ContentTitle">Production&R&D</div>
        <div class="Production1ContentTitleCn">生产与研发</div>
        <div class="Production1ContentSubstance">
          <div v-for="(item, index) in production" :key="index"
            :class="productionindex == index ? 'ProductionSubstanceActive' : 'ProductionSubstanceNormal'"
            @click="productionindex = index">
            <div>0{{ index + 1 }}</div>
            <div>{{ item.title }}</div>
          </div>

        </div>
        <div class="Production1ContentSubstanceText" v-show="productionindex == 0 || productionindex == 2">
          {{ production[productionindex].text }}
        </div>
        <div v-show="productionindex == 1">
          <div class="productionindex1Text">
            <span style="margin-left: 92px;">2.配置调和</span>
            <span style="margin-left: 131px;">
              <div>4.取样封存</div>
              <div style="font-size: 20px;line-height: 20px;">（≥6个月）</div>
            </span>
            <span style="margin-left: 126px;">6.成品交付</span>
          </div>
          <img style="width: 700px;height: 61px;margin-left: 47px;" src="../assets/img/Group71.png" alt="">
          <div class="productionindex2Text">
            <span style="margin-left: -12px;">1.原料检测</span>
            <span style="margin-left: 126px;">3.成品检测</span>
            <span style="margin-left: 114px;">5.成品入库</span>
          </div>
        </div>
      </div>
      <div class="Production1Right">
        <img class="Production1RightImg" :src="production[productionindex].src" alt="">
        <img class="Production1RightImg1" src="../assets/img/home_Rd_bg1.png" alt="">
        <div class="Production1RightText">
          <span class="Production1RightIndex">0{{ productionindex + 1 }}</span><span
            class="Production1RightextMid">/</span> 03
        </div>
      </div>
    </section>
    <section class="develop">
      <div class="developBg"></div>
      <div class="developContent">
        <div class="developContentTitle">
          <div><span style="color: #318DD1;">U</span>DIAN</div>
          <div style="font-size: 36px;margin-top: 15px;font-weight: 800;">发展历程</div>
          <div style="font-size: 24px;margin-top: 9px;">Historys</div>
        </div>
        <div class="milestone">
          <div v-for="(item, index) in develop" :key="index" class="milestoneList">
            <div class="milestoneListText">{{ item.text }}</div>
            <div class="milestoneListTime">
              <span>{{ item.time }}</span>
            </div>
            <div class="milestoneListTime1">{{ item.time1 }}</div>
          </div>
        </div>
        <div class="developHonors">
          <div>荣誉资质</div>
          <div>Honors</div>
        </div>
        <div class="developHonorsImg">
          <div v-for="(item, index) in developImg" :key="index">
            <img :src="item" alt="">
          </div>
        </div>
      </div>
    </section>
    <Products />
    <subsidiary />
    <platform />
    <Contact />
    <footerRouter></footerRouter>
  </div>
</template>
<script>
import Products from '../components/Products.vue'
import subsidiary from '../components/subsidiary.vue'
import platform from '../components/platform.vue'
import Contact from '../components/Contact.vue'
import footerRouter from '../components/footerRouter.vue'
import Swiper from 'swiper'
export default {
  name: "HomePage",
  components: { Products, subsidiary, platform, Contact, footerRouter },
  data() {
    return {
      production: [
        {
          title: '产品研发中心',
          src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/home_Rd_img.png',
          text: '我们定位于引领行业的中高端市场，集团旗下设有油品添加剂研发部、油品复合剂研发部、油品成品研发部等多部门协同开发。为润滑油企业上下游的生产、调配提供各类添加剂、复合剂等原料；为润滑油贸易商、渠道经销商提供集团旗下的产品及OEM代加工服务。'
        }, {
          title: '生产工艺流程',
          src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/home_Rd_img1.png',
        }, {
          title: '生产车间',
          src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/home_Rd_img.png',
          text: '生产车间采用自动化管理， 存储罐阀门和机泵互锁， 可根据配方管理程序自动启停， 存储罐都配备了自动定量局部加热器， 避免了传统工艺中加热不均匀、能耗高、原料易氧化变质的缺陷。 生产区配有全自动调合装置，采用称重式计量， 提高生产效率及产品品质。油品转存采用精密过滤器，确保油品的清洁度。 灌装线之间采用单管单线独立工艺管道，与成品罐使用快速接头，独立连接，确保分装过程不受管道残油影响，保证每一批产品的质量。'
        }
      ],
      productionindex: 0,
      develop: [
        {
          text: '以研发产品\n' + '服务终端客户为主\n' + '十年发展累积海量\n' + '服务客户数据',
          time: '成立初期',
          time1: '2009-2017年'
        }, {
          text: '布局全国市场\n' + '建立经销商渠道\n' + '0到1建立全国经销商渠道',
          time: '企业转型',
          time1: '2018年',
        }, {
          text: '全国发展4000+\n' + '稳定渠道经销商',
          time: '规模发展',
          time1: '2019-2020年',
        }, {
          text: '线上商城、分销系统和采购系统，实现垂直领域定制化，OEM代加工',
          time: '平台搭建',
          time1: '2021-2022年'
        }, {
          text: '年复增长率20%\n' + '全年销量突破3万吨',
          time: '业绩地位',
          time1: '2023年'
        }, {
          text: '全国多地区投资建厂\n' + '投资规模8000万元',
          time: '规模化布局',
          time1: '2024年'
        }, {
          text: '制定行业标准\n' + '引领行业未来',
          time: '展望',
          time1: ''
        }
      ],
      developImg: [
        'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/fazhan_imq1.png',
        'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/fazhan_imq2.png',
        'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/fazhan_imq3.png',
        'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/fazhan_imq4.png',
        'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/fazhan_imq5.png',
        'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/fazhan_imq6.png',
        'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/fazhan_imq8.png',
        'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/fazhan_imq9.png',
      ],
      swiperList: [
        // require('../assets/img/home.png'),
        // require('../assets/img/home.png'),
        // require('../assets/img/home.png'),
      ]
    }
  },
  created() {
    this.http.get(`api/homepage`).then(res => {
      if (res.status == '200' && res.data.code == 0 && Object.keys(res.data.data).length > 0) {
        this.swiperList = res.data.data
      }
    })
  },
  mounted() {
    new Swiper(".banner-swiper", {
      loop: true,
      effect: 'fade',
      observer: true,
      observeParents: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });
  },
  computed: {

  },
};
</script>
<style scoped>
.HomePage {
  background: #F3F3F3;
}

.Page1 {
  width: 100%;
  /* height: 100vh; */
}

#swiper {
  height: 100%;
}

.swiper-lazy {
  height: 100%;
  width: 100%;
}

#swiper .banner-swiper {
  height: 100%;
}

#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 363px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  color: #FFFFFF;
}

#swiper .banner-swiper .swiper-slide-title>img {
  width: 216.11px;
  height: 215px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

#swiper .banner-swiper .swiper-slide-title>h1 {
  font-size: 64px;
  margin-top: 25px;
  line-height: 75px;
  font-weight: 800;
}

#swiper .banner-swiper .swiper-slide-title>p {
  font-size: 64px;
  font-family: PingFang SC-Regular;
  font-weight: 200;
  /* margin-top: 1%; */
  /* font-weight: 700; */
}

.HomePage .Page1 .content {
  position: absolute;
  top: 388px;
  left: 216px;
  width: calc(100% - 358px);
  z-index: 9;
}

.HomePage .Page1 .content .title {
  /* width: 360px; */
  height: 50px;
  font-family: PingFang SC, PingFang SC;
  /* font-weight: 800; */
  font-size: 36px;
  color: #45AFFF;
  line-height: 42px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.HomePage .Page1 .content .text {
  margin-top: 16px;
  /* width: 600px; */
  height: 140px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 60px;
  color: #FFFFFF;
  line-height: 70px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  position: relative;
}

.HomePage .Page1 .content .text::before {
  content: ' ';
  display: block;
  width: 11px;
  height: 147px;
  background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
  border-radius: 0px 0px 0px 0px;
  position: absolute;
  left: -27px;
}

.HomePage .Page1 .content .text-en {
  margin-top: 57px;
  width: 750px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 23px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.Production {
  height: 1678px;
  position: relative;
}

.Production .left-img {
  width: 1031px;
  height: 1060px;
  position: absolute;
  top: -200px;
  left: -200px;
  z-index: 2;
}

.Production .left-img1 {
  width: 605px;
  height: 599px;
  position: absolute;
  top: 293px;
  left: 263px;
  z-index: 1;
}

.Production .right {
  position: absolute;
  width: calc(100vw - 120px);
  height: 1519px;
  background: #fff;
  right: 0;
  top: 101px;
}

.Production .right .text-img {
  width: 628px;
  height: 250px;
  position: absolute;
  right: 0;
  top: 21px;
}

.Production .right .title {
  position: absolute;
  top: 115px;
  left: 829px;
  font-weight: 800;
  font-size: 44px;
  color: #373737;
}

.Production .right .title:before {
  position: absolute;
  content: ' ';
  left: -44px;
  top: 25px;
  display: block;
  width: 11px;
  height: 121px;
  background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
  border-radius: 0px 0px 0px 0px;
}

.Production .right .title>div:first-child {
  font-weight: 400;
  font-size: 70px;
}

.Production .right .text-1 {
  position: absolute;
  top: 353px;
  left: 829px;
  color: #373737;
  font-size: 32px;
}

.Production .right .text-1 .company {
  font-weight: 800;

}

.Production .right .text-1 .address-icon {
  display: inline-block;
  width: 24px;
  height: 27px;
  margin-left: 100px;
}

.Production .right .text-1 .address {
  font-size: 28px;
  font-weight: 400;
}

.company-en {
  color: #989898;
  font-size: 20px;
  margin-top: 10px;
}

.company-introduction {
  width: 809px;
  height: 111px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #373737;
  line-height: 38px;
  letter-spacing: 3px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 26px;
}

.production-bottom-img1 {
  position: absolute;
  bottom: 97px;
  right: 0;
  width: 841px;
  height: 579px;
  z-index: 1;
}

.production-bottom-img2 {
  position: absolute;
  bottom: 42px;
  right: 282px;
  width: 590px;
  height: 588px;
}

.production-bottom-content {
  position: absolute;
  top: 918px;
  left: 68px;

}

.production-bottom-purpose {
  width: 684px;
  height: 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 32px;
  color: #373737;
  line-height: 38px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 11px;
}

.production-bottom-purpose::before {
  position: absolute;
  content: ' ';
  left: -68px;
  top: 0;
  display: block;
  width: 11px;
  height: 67px;
  background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
  border-radius: 0px 0px 0px 0px;
}

.production-bottom-purpose-en {
  width: 268px;
  height: 22px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #989898;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.production-bottom-purpose-title {
  width: 816px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #45AFFF;
  line-height: 38px;
  letter-spacing: 3px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 43px;
}

.production-bottom-purpose-text {
  width: 816px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #373737;
  line-height: 38px;
  letter-spacing: 3px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.Production1 {
  height: 1080px;
  padding: 101px 356px 101px 0;
  position: relative;

}

.Production1Content {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 53px 0 0 189px;
}

.Production1ContentTitle {
  width: 542px;
  height: 98px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 70px;
  color: #373737;
  line-height: 82px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  position: relative;
}

.Production1ContentTitle::before {
  position: absolute;
  content: ' ';
  left: -39px;
  top: 15px;
  display: block;
  width: 11px;
  height: 121px;
  background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
  border-radius: 0px 0px 0px 0px;
}

.Production1ContentTitleCn {
  width: 220px;
  height: 62px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 44px;
  color: #373737;
  line-height: 52px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: -10px;
}

.Production1ContentSubstance {
  margin-top: 109px;
  position: relative;
}

.Production1ContentSubstance::before {
  content: ' ';
  display: inline-block;
  position: absolute;
  left: -39px;
  top: 0;
  width: 3px;
  height: 448px;
  background: rgba(69, 175, 255, 0.39);
  border-radius: 0px 0px 0px 0px;
}

.Production1ContentSubstanceText {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 26px;
  color: #373737;
  line-height: 42px;
  letter-spacing: 3px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  width: 785px;
  margin-top: 74px;
}

.Production1ContentSubstance>div {
  width: 254px;
  display: inline-block;
  text-align: center;
  padding-top: 24px;
}

.Production1ContentSubstance>div>div:first-child {
  height: 70px;
  font-family: Ruda, Ruda;
  font-weight: 500;
  font-size: 64px;
  color: #D1D1D1;
  line-height: 75px;
  font-style: normal;
  text-transform: none;
}

.Production1ContentSubstance>div>div:last-child {
  height: 28px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 24px;
  color: #373737;
  line-height: 28px;
  font-style: normal;
  text-transform: none;
  margin-top: 7px;
}

.ProductionSubstanceActive {
  height: 176px;
  background: url('../assets/img/Group27.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.Production1ContentSubstance .ProductionSubstanceActive>div {
  color: #FFFFFF !important;
}

.ProductionSubstanceNormal {
  height: 159px;
  border: 1px solid #B6B6B6;
}

.Production1Right {
  width: 698px;
  height: 645px;
  background: #45AFFF;
  border-radius: 323px 0px 0px 323px;
  position: absolute;
  top: 218px;
  right: 0;
}

.Production1RightImg {
  position: absolute;
  top: 76px;
  left: -214px;
  width: 683px;
  height: 489px;
  z-index: 1;
}

.Production1RightImg1 {
  width: 642px;
  height: 697px;
  position: absolute;
  top: -15px;
  right: 255px;
}

.Production1RightText {
  position: absolute;
  left: 464px;
  top: 287px;
  font-family: Ruda, Ruda;
  font-weight: 500;
  font-size: 36px;
  color: rgba(255, 255, 255, 0.31);
  line-height: 42px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.Production1RightIndex {
  width: 80px;
  display: inline-block;
  height: 70px;
  font-size: 64px;
  color: #FFFFFF;
  line-height: 75px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.Production1RightextMid {
  position: relative;
  top: -5px;
}

.develop {
  height: 1963px;
  position: relative;
}

.developBg {
  position: absolute;
  top: 0;
  height: 1118px;
  width: 100%;
  background: url('../assets/img/Slice3.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.developContent {
  position: absolute;
  left: 189px;
  top: 127px;
  z-index: 1;
}

.developContentTitle {
  font-family: HanWangZonYi, HanWangZonYi;
  font-weight: 400;
  font-size: 24px;
  color: #fff;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.developContentTitle::before {
  content: ' ';
  display: block;
  width: 11px;
  height: 106px;
  background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
  border-radius: 0px 0px 0px 0px;
  position: absolute;
  left: -40px;
}

.milestone {
  display: flex;
  color: #fff;
  margin-top: 48px;
  text-align: center;
  padding-right: 185px;
}

.milestoneList {
  margin-right: 48px;
  flex: 1;
}

.milestoneListText {
  min-height: 150px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  line-height: 34px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.milestoneListTime>span {
  display: inline-block;
  padding: 5px 32px;
  background: rgba(255, 255, 255, 0.21);
  border-radius: 10px 10px 10px 10px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 23px;
  font-style: normal;
  text-transform: none;
  margin-bottom: 20px;
}

.milestoneListTime1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 30px;
  color: #FFFFFF;
  line-height: 38px;
  font-style: normal;
  text-transform: none;
}

.developHonors {
  margin-top: 89px;
  font-family: PingFang SC, PingFang SC;
  font-size: 36px;
  color: #FFFFFF;
  line-height: 42px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  position: relative;
}

.developHonors>div:first-child {

  font-weight: 800;
}

.developHonors>div:last-child {

  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
}

.developHonors::before {
  content: ' ';
  display: block;
  width: 11px;
  height: 60px;
  background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
  border-radius: 0px 0px 0px 0px;
  position: absolute;
  left: -40px;
  top: 5px;
}

.developHonorsImg {
  margin-top: 92px;
  display: flex;
  flex-wrap: wrap;
  /* 允许换行 */
  justify-content: space-between;
  /* 分散对齐 */
  padding-right: 92px;
}

.developHonorsImg>div {
  width: 25%;
}

.developHonorsImg {}

.developHonorsImg img {
  width: 432px;
  height: 557px;
}

.productionindex1Text {
  display: flex;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 26px;
  color: #373737;
  line-height: 42px;
  letter-spacing: 3px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.productionindex2Text {
  margin-top: 30px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 26px;
  color: #373737;
  line-height: 42px;
  letter-spacing: 3px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue